import { Container, Title, Text, Stack, Divider } from '@mantine/core';

export default function TermsOfService() {
  return (
    <Container size="sm" pt="md" pb="xl">
      <Stack gap="lg">
        <Title order={1}>Terms of Service</Title>
        <Text c="dimmed" size="sm">
          Last updated: {new Date().toLocaleDateString()}
        </Text>

        <Divider />

        <Stack gap="md">
          <Title order={3}>1. Acceptance of Terms</Title>
          <Text>
            By accessing or using CartCritic, you agree to be bound by these Terms of Service.
            If you do not agree to these terms, please do not use our service.
          </Text>

          <Title order={3}>2. User Accounts</Title>
          <Text>
            You must provide accurate information when creating an account. You are responsible for
            maintaining the security of your account and password. You must be at least 13 years old
            to use CartCritic.
          </Text>

          <Title order={3}>3. User Content</Title>
          <Text>
            You retain ownership of content you post (reviews, comments, images). By posting content,
            you grant CartCritic a license to display, distribute, and promote your content within the
            service. You are responsible for ensuring your content does not violate any laws or
            third-party rights.
          </Text>

          <Title order={3}>4. Prohibited Conduct</Title>
          <Text>
            You may not: post false or misleading reviews; harass or abuse other users; spam or post
            unsolicited advertising; attempt to access other users' accounts; use automated tools to
            scrape or interact with the service; or violate any applicable laws.
          </Text>

          <Title order={3}>5. Affiliate Links & Advertising</Title>
          <Text>
            CartCritic contains affiliate links to Amazon.com and may display sponsored product
            recommendations. As an Amazon Associate, CartCritic earns from qualifying purchases.
            Affiliate links are clearly labeled as paid links. Product prices and availability shown
            from Amazon are subject to change.
          </Text>

          <Title order={3}>6. Content Moderation</Title>
          <Text>
            We reserve the right to remove content that violates these terms or our community
            guidelines. We may suspend or terminate accounts that repeatedly violate our policies.
          </Text>

          <Title order={3}>7. Disclaimers</Title>
          <Text>
            CartCritic is provided "as is" without warranties of any kind. Product information,
            including prices and availability from third-party sources like Amazon, is subject to
            change and may not always be accurate. We are not responsible for purchases made through
            affiliate links.
          </Text>

          <Title order={3}>8. Limitation of Liability</Title>
          <Text>
            CartCritic shall not be liable for any indirect, incidental, special, or consequential
            damages arising from your use of the service.
          </Text>

          <Title order={3}>9. Changes to Terms</Title>
          <Text>
            We may update these terms from time to time. Continued use of CartCritic after changes
            constitutes acceptance of the updated terms.
          </Text>

          <Title order={3}>10. Contact Us</Title>
          <Text>
            If you have questions about these terms, please contact us at support@cartcritic.app.
          </Text>
        </Stack>
      </Stack>
    </Container>
  );
}
